/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-30 11:39:04
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { getShop } from 'src/helpers';
import { Field } from 'redux-form';
import { Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderSelect } from 'src/components/views/common/forms/render-select';
import { RenderDateRangePicker } from './render-date-range-picker';
import { RANKING_TYPE } from 'src/constants/product-ranking';
import noProductImage from 'src/assets/images/product/no-product-image.png';
import { optimizeImage } from 'src/helpers';

type Props = {
  item: Object,
  index: number,
  productRanking: Object,
  onChooseDate: () => void,
  appLanguage: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  onHover: boolean
};
// DONE
class TableRow extends Component<ComposedProps, State> {
  state = {
    onHover: false
  };

  render() {
    const { onHover } = this.state;
    const { item, productRanking, index, appLanguage, i18n } = this.props;

    const dataItem =
      !_.isEmpty(productRanking) && productRanking[index] ? productRanking[index] : {};
    const shop = getShop();
    const url = `https://${shop}/admin/products/${dataItem.id}`;
    const { images } = dataItem;
    const firstImageIndex = !_.isEmpty(images) ? Object.keys(images)[0] : null;
    let image = !firstImageIndex
      ? noProductImage
      : optimizeImage(images[firstImageIndex], '100x100');

    // Check disable of date picker popover
    const formattedRankingTypes = RANKING_TYPE.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const rankingType = dataItem ? dataItem.rankingType : '';
    const findResult = _.find(formattedRankingTypes, { value: rankingType });
    const disabled = _.isEmpty(findResult) || rankingType === '' ? true : false;

    return (
      <React.Fragment>
        <tr
          className={`Polaris-DataTable__TableRow ${onHover ? 'hover' : ''}`}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}>
          {/* Product Id - hide */}
          {/*<td className="Polaris-DataTable__Cell">
            <div className="product-id">
              <span>{dataItem.id}</span>
            </div>
          </td>*/}
          {/* Product Image */}
          <td className="Polaris-DataTable__Cell">
            <div className={`product-image ${_.isEmpty(images) ? 'no-image' : ''}`}>
              <img src={image} alt={dataItem.productTitle} />
            </div>
          </td>
          {/* Product title */}
          <td className="Polaris-DataTable__Cell">
            <div>
              <Link removeUnderline external url={url}>
                {dataItem.title}
              </Link>
            </div>
          </td>
          {/* Product ranking type */}
          <td className="Polaris-DataTable__Cell">
            <Field
              name={`${item}.rankingType`}
              options={formattedRankingTypes}
              component={RenderSelect}
            />
          </td>
          {/* Product ranking date */}
          <td className="Polaris-DataTable__Cell">
            <RenderDateRangePicker
              enabledFromDate={dataItem.enabledFromDate}
              enabledToDate={dataItem.enabledToDate}
              onChooseDate={this.props.onChooseDate}
              index={index}
              disabled={disabled}
              appLanguage={appLanguage}
            />
          </td>
        </tr>
        {dataItem.rankingType === 'keywordSearch' ? (
          <tr
            className={`Polaris-DataTable__TableRow ${onHover ? 'hover' : ''}`}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}>
            <td className="Polaris-DataTable__Cell" colSpan="3"></td>
            <td className="Polaris-DataTable__Cell" colSpan="2">
              {/* Product ranking key word search */}
              <Field
                name={`${item}.keywords`}
                component={RenderTextField}
                placeholder={i18n.translate('AdminHTML.ProductRanking.TableRow.field_Placeholder')}
              />
            </td>
          </tr>
        ) : (
          <tr />
        )}
      </React.Fragment>
    );
  }

  // Handle hover on the tr
  onMouseEnter = () => {
    this.setState({ onHover: true });
  };
  onMouseLeave = () => {
    this.setState({ onHover: false });
  };
}

export default withI18n()(TableRow);
